import { render } from "./linkMenuDialog.vue?vue&type=template&id=3b5927ba&scoped=true"
import script from "./linkMenuDialog.vue?vue&type=script&lang=js"
export * from "./linkMenuDialog.vue?vue&type=script&lang=js"

import "./linkMenuDialog.vue?vue&type=style&index=0&id=3b5927ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b5927ba"]])

export default __exports__